<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar w-p-100 flex flex-row justify-start items-center">
    <button class="mr-sm-16 mat-icon-button back-btn" mat-icon-button="" tabindex="0" (click)="back()">
      <mat-icon class="mat-icon ng-tns-c39-36 material-icons" role="img"
                aria-hidden="true">arrow_back
      </mat-icon>
    </button>

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="addUser()"
                  [disabled]="!companySource.includes('orbitax')"
                  particleAnalytics
                  analyticsCategory="projects-content"
                  analyticsAction="add project">Add User
          </button>

          <div class="toolbar-separator"></div>
        </div>

      </div>
    </div>

    <button mat-button class="m-l-auto start-data-survey m-l-10" (click)="executeCompanyConfigDialogCommand()"
            [disabled]="false"
            particleAnalytics
            analyticsCategory="projects-content"
            analyticsAction="add project">Configuration
    </button>
  </div>
  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg parent-tab-for-grid">
        <mat-tab-group>
          <mat-tab label="Company Details">
            <form class="p-30 flex flex-col" *ngIf="detailForm" [formGroup]="detailForm">
              <div class="flex flex-col">

                <div class="flex flex-row justify-start items-start auto-flex"
                     *ngIf="isEditing.companyName === false">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="companyName" (click)="editField('companyName')"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <particle-inplace-input *ngIf="isEditing.companyName === true"
                                        [text]="detailForm.value.companyName"
                                        placeHolder="Company Name"
                                        (valueChanged)="saveFieldData($event, 'companyName')"
                                        (cancelled)='resetEditing()'>
                </particle-inplace-input>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Company ID</mat-label>
                    <input matInput formControlName="companyId"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex"
                     *ngIf="isEditing.description === false">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Description</mat-label>
                    <input matInput formControlName="description" (click)="editField('description')"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <particle-inplace-input *ngIf="isEditing.description === true"
                                        [text]="detailForm.value.description"
                                        placeHolder="Description"
                                        (valueChanged)="saveFieldData($event, 'description')"
                                        (cancelled)='resetEditing()'>
                </particle-inplace-input>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Source</mat-label>
                    <input matInput formControlName="source"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex"
                     *ngIf="isEditing.domain === false">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Domain</mat-label>
                    <input matInput formControlName="domain" (click)="editField('domain')"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <particle-inplace-input *ngIf="isEditing.domain === true"
                                        [text]="detailForm.value.domain"
                                        placeHolder="Domain"
                                        (valueChanged)="saveFieldData($event, 'domain')"
                                        (cancelled)='resetEditing()'>
                </particle-inplace-input>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-checkbox formControlName="isActive" (change)="updateCompanyData()">Is Active</mat-checkbox>
                </div>

              </div>
            </form>
          </mat-tab>
          <mat-tab label="User Lists">
            <div class="w-p-100 h-p-100 p-30 flex flex-col">

              <div class="pos-relative m-t-20 full-grow-no-shrink-no-basis">
                <div class="keno-grid-container">
                  <particle-smart-grid [sourceType]="sourceType" (valueChanged)="onValueChanged($event)">
                  </particle-smart-grid>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-sidenav-container>
</div>
